module.exports = __webpack_public_path__ + "img/icon_sb_rating_alt_desktop_v2.71bb32c.svg";